import React from 'react';

const Skincare = () => {
  return (
    <div className="menu-bot smaller-menu">
      <h5 className="services-sub">SKIN CARE</h5>
      <table className="table-menu">
        <tbody>
          <tr>
            <td className="column-block">
              <div>
                <strong className="menu menu-title">
                  Basic European Facial
                </strong>
              </div>
            </td>
            <td className="column-block menu-price small-menu-text-left">
              <span>$50</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
export default Skincare;
